

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { BsCurrencyRupee } from "react-icons/bs";
import { FaUserCircle } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { MdAssignmentTurnedIn } from "react-icons/md";
import { MdCheckCircleOutline } from "react-icons/md";
import { AiOutlineBarChart } from "react-icons/ai";
import { MdOutlineStackedLineChart } from "react-icons/md";
import { HiCollection } from "react-icons/hi";
import { TbReportSearch } from "react-icons/tb";
import {AiOutlineDollar} from "react-icons/ai";
import Swal from "sweetalert2";
import axios from "axios";

export default function Sidebar() {
  const navigate = useNavigate();
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [themeColor, setThemeColor] = useState(
    "radial-gradient(circle at 12.3% 19.3%, rgb(85, 88, 218) 0%, rgb(95, 209, 249) 100.2%)"
  );
  const fetchThemeColor = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/fetchSetup`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

  
      const data = response.data;
  
      if (data && data.length > 0) {
        setThemeColor(data[0].theme_color || "#000000");
        console.log("theme color updated");
      }
    } catch (error) {
      console.error("Error fetching theme color:", error);
    }
  };
  
  useEffect(() => {
    fetchThemeColor();
  }, []);
 

  const handleLogoutConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/Logout");
      }
    });
  };



  const toggleSidebar = () => {
    setSidebarVisible(prevState => !prevState);
  };
  

  return (
    <>
      {/* Hamburger menu button */}
      <button
        onClick={toggleSidebar}
        type="button"
        className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-amber-400 rounded-lg sm:hidden hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
      >
        <span className="sr-only">Open sidebar</span>
        <svg
          className="w-6 h-6"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clipRule="evenodd"
            fillRule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
          ></path>
        </svg>
      </button>

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 z-40 w-64 h-screen transform transition-transform duration-300 ${isSidebarVisible ? "translate-x-0" : "-translate-x-full"} sm:translate-x-0 bg-blue-700 dark:bg-gray-800`}
        aria-label="Sidebar"
        style={{ backgroundColor: themeColor }}
      >
      
        <div className="h-full px-3 py-4 overflow-y-auto bg-blue-700 dark:bg-gray-800" style={{ backgroundColor: themeColor }}>
          <div className="flex items-center justify-contents-center ps-2.5 mb-5">
            <Link data-drawer-hide="sidebar-multi-level-sidebar" to="/"></Link>
          </div>
          <ul className="space-y-2 font-medium">
            {/* Sidebar links */}
            <li>
              <Link to="/Dashboard" onClick={() => setSidebarVisible(false)}>
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <svg
                    className="w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 22 21"
                  >
                    <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
                    <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
                  </svg>
                  <span className="ms-3 md:hidden lg:block">Dashboard</span>
                </div>
              </Link>
            </li>

            
            <li>
              <Link
                data-drawer-hide="sidebar-multi-level-sidebar"
                to="/Investor" onClick={() => setSidebarVisible(false)}
              >
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <BsCurrencyRupee className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">Investor</span>
                </div>
              </Link>
            </li>

            <li>
              <Link
                data-drawer-hide="sidebar-multi-level-sidebar"
                to="/CollectionAgent" onClick={() => setSidebarVisible(false)}
              >
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <FaUserCircle className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">
                    Collection Agent
                  </span>
                </div>
              </Link>
            </li>

            <li>
              <Link
                data-drawer-hide="sidebar-multi-level-sidebar"
                to="/Customers" onClick={() => setSidebarVisible(false)}
              >
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <FaUsers className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">Customer</span>
                </div>
              </Link>
            </li>

            <li>
              <Link
                data-drawer-hide="sidebar-multi-level-sidebar"
                to="/AssignAccount" onClick={() => setSidebarVisible(false)}
              >
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <MdAssignmentTurnedIn className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">
                    Assign Account
                  </span>
                </div>
              </Link>
            </li>

            <li>
              <Link
                data-drawer-hide="sidebar-multi-level-sidebar"
                onClick={() => setSidebarVisible(false)}
                to="/SchemeCreation" 
              >
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <AiOutlineBarChart className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">
                    Scheme Creation
                  </span>
                </div>
              </Link>
            </li>

            <li>
              <Link data-drawer-hide="sidebar-multi-level-sidebar" to="/Loan" onClick={() => setSidebarVisible(false)}>
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <MdOutlineStackedLineChart className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">Loan</span>
                </div>
              </Link>
            </li>

            <li>
              <Link
                data-drawer-hide="sidebar-multi-level-sidebar"
                to="/LoanCollection" onClick={() => setSidebarVisible(false)}
              >
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <HiCollection className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">
                    Loan Collection
                  </span>
                </div>
              </Link>
            </li>
            <li>
              <Link
                data-drawer-hide="sidebar-multi-level-sidebar"
                to="/Attendance" onClick={() => setSidebarVisible(false)}
              >
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <MdCheckCircleOutline className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">
                    Attendance
                  </span>
                </div>
              </Link>
            </li>

            <li>
              <Link
                data-drawer-hide="sidebar-multi-level-sidebar"
                onClick={() => setSidebarVisible(false)}
                to="/Advance" 
              >
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <AiOutlineDollar className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">
                    Advance
                  </span>
                </div>
              </Link>
            </li>


            <li>
              <Link
                data-drawer-hide="sidebar-multi-level-sidebar"
                to="/ReportPage" onClick={() => setSidebarVisible(false)}
              >
                <div className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group">
                  <TbReportSearch className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white" />

                  <span className="ms-3 md:hidden  lg:block">Report</span>
                </div>
              </Link>
            </li>

            <li>
              <div
                className="flex items-center p-2 text-slate-100 rounded-lg dark:text-white hover:bg-blue-900 dark:hover:bg-gray-700 group"
                onClick={handleLogoutConfirmation} 
              >
                <svg
                  className="flex-shrink-0 w-6 h-6 text-amber-400 transition duration-75 dark:text-gray-400 group-hover:text-slate-100 dark:group-hover:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 18 16"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 8h11m0 0L8 4m4 4-4 4m4-11h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3"
                  />
                </svg>
                <span className="flex-1 ms-3 md:hidden whitespace-nowrap lg:block">Logout</span>
              </div>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
}


